import React from 'react';
import heroVideo from '../assets/hero-video.mp4'; // replace with your video file

export default function Hero() {
  return (
    <div className="text-center py-16 sm:py-20 bg-gradient-to-br from-cyan-100 via-teal-50 to-white px-4">
      <div className="max-w-[1400px] mx-auto">
        <span className="inline-block px-4 py-1 mb-4 rounded-full bg-teal-100 text-teal-700 text-xs font-semibold tracking-wide uppercase">
          Rapid Bacteria Detection
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold text-teal-700 mb-3 tracking-tight">
          Citispring
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Rapid Quality Check for Safe Drinking Water
        </p>

        {/* Big Video */}
        <video
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
          className="mx-auto w-full max-h-[600px] rounded-2xl shadow-xl ring-1 ring-black/5"
        />
      </div>
    </div>
  );
}
